export const GET_ADMIN_HOME = 'GET_ADMIN_HOME';
export const GET_ADMIN_HOME_SUCCESS = 'GET_ADMIN_HOME_SUCCESS';
export const GET_ADMIN_HOME_FAILURE = 'GET_ADMIN_HOME_FAILURE';
// Admin Home Box
export const GET_ADMIN_HOME_BOX = 'GET_ADMIN_HOME_BOX';
export const GET_ADMIN_HOME_BOX_SUCCESS = 'GET_ADMIN_HOME_BOX_SUCCESS';
export const GET_ADMIN_HOME_BOX_FAILURE = 'GET_ADMIN_HOME_BOX_FAILURE';
